/* eslint-disable prettier/prettier */
/* eslint-disable radix */
export class CitySetting {
    constructor(settings) {
        this.region = settings.region;
        this.Latitude = parseFloat(settings.Latitude);
        this.Longitude = parseFloat(settings.Longitude);
        this.bookingurl = settings.bookingurl;
        this.apiurl = settings.apiurl;
        this.Bindurl = settings.Bindurl;
        this.regionen = settings.regionen;
        this.pathname = settings.pathname;
        this.webtitle = settings.webtitle;
        this.organization = settings.organization;
        this.bindmyself = settings.bindmyself;
        this.bindfamily = settings.bindfamily;
        this.liffId = settings.liffId;
        this.webbookingurl = settings.webbookingurl;
        this.ColorHex = settings.ColorHex;
        this.display_name = settings.display_name;
    }

    // 獲取格式化的位置字符串
    getLocationString() {
        return `${this.Latitude}, ${this.Longitude}`;
    }

    // 檢查是否支持自己綁定
    supportsSelfBinding() {
        return this.bindmyself !== "";
    }

    // 獲取家屬綁定數量限制
    getFamilyBindingLimit() {
        const match = this.bindfamily.match(/至多可綁定(\w+)位家屬/);
        if (match) {
            const numberMap = { '兩': 2, '四': 4 };
            return numberMap[match[1]] || parseInt(match[1]);
        }
        return null; // 如果無法解析，返回 null
    }

    // 檢查是否會推送通知
    pushesNotifications() {
        return this.bindfamily.includes("會主動推播上下車時間");
    }
}